import './i18n'; // Importer i18next
import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import App from './App';
import { ToastProvider } from './components/admin/ui';
import AppErrorBoundary from './components/AppErrorBoundary';
import { DEMO_MODE } from './services/demoMode';
import './index.css';

// v5 SAFETY: capture les erreurs globales pour éviter l'écran noir bloqué
window.addEventListener('error', (e) => {
  console.error('[GlobalError]', e.error || e.message);
});
window.addEventListener('unhandledrejection', (e) => {
  console.error('[UnhandledRejection]', e.reason);
});

// v5 UX: intercepte window.alert pour le rediriger vers le système de toasts
// Cela évite d'avoir à remplacer 24 alert() un par un (risqué).
// Les alerts existantes deviennent automatiquement des toasts non-bloquants.
// L'admin a toujours moyen de voir le message mais sans interrompre son flow.
(() => {
  const originalAlert = window.alert.bind(window);
  window.alert = (message?: any) => {
    const msg = String(message ?? '');
    // Détection heuristique du type de message
    let type: 'success' | 'error' | 'warning' | 'info' = 'info';
    const lower = msg.toLowerCase();
    if (msg.includes('✓') || lower.includes('succès') || lower.includes('réussi') || lower.includes('enregistr')) {
      type = 'success';
    } else if (msg.includes('⚠') || lower.includes('attention') || lower.includes('veuillez')) {
      type = 'warning';
    } else if (lower.includes('erreur') || lower.includes('impossible') || lower.includes('échec') || lower.includes('invalide')) {
      type = 'error';
    }
    // Dispatch sur l'event bridge utilisé par ToastProvider
    try {
      window.dispatchEvent(
        new CustomEvent('admin:toast', {
          detail: { type, message: msg, duration: type === 'error' ? 4000 : 2500 },
        })
      );
    } catch (_) {
      // Fallback : alert classique si le toast n'est pas dispo
      originalAlert(msg);
    }
  };
})();

const renderApp = () => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <AppErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </I18nextProvider>
    </AppErrorBoundary>
  );
};

// v5 mode démo : applique les réglages en dur AVANT le rendu (l'app les lit au démarrage).
// `?demo=1&config=1` = mode RÉGLAGE : on garde les personnalisations en cours même après
// un rechargement, le temps de les recapturer dans demoSettings.json.
const DEMO_CONFIG_SESSION = new URLSearchParams(window.location.search).get('config') === '1';
if (DEMO_MODE && !DEMO_CONFIG_SESSION) {
  import('./demo/applyDemoDefaults')
    .then(({ applyDemoDefaults }) => applyDemoDefaults())
    .catch((error) => console.error('[DEMO] Chargement des réglages démo impossible:', error))
    .finally(renderApp);
} else {
  renderApp();
}
